import React, { FunctionComponent, useState } from 'react'

//Custom
import {MapContext} from "./MapContext";

const MapContextProvider = (props) => {

  const [forceRefreshCounter, setForceRefreshCountrs] = useState(0);

  const { map, initOptions } = props;

  const setLayerVisibility = (id, isVisible) => {
    const key = "maplayers";
    const item = localStorage.getItem(key)
    const settings = item ? JSON.parse(item) : null;
    if (settings === null || Object.keys(settings).length === 0) {
      localStorage.setItem(key, JSON.stringify({ [id]: isVisible }));
    } else {
      settings[id] = isVisible;
      localStorage.setItem(key, JSON.stringify(settings));
    }

    setForceRefreshCountrs(prev => prev + 1);
  }

  const getLayerVisibility = () => {
    const key = "maplayers";

    const item = localStorage.getItem(key)
    const settings = item ? JSON.parse(item) : null;

    return settings ? settings : {};
  }

  const providerValue = {
    map,
    initOptions,
    setLayerVisibility,
    getLayerVisibility,
    forceRefreshCounter

  }

  return (
    <MapContext.Provider value={providerValue}>
      {props.children}
    </MapContext.Provider>
  )

}

export default MapContextProvider;